
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import bannerlogo from "../../assets/LMS-Banner.jpeg";
import Carousel from "./Carousel.jsx";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext.jsx";
import { useCampaign } from '../../Context/CampaignContext.jsx';

const Home = ({
  studentReferral,
  activeTab,
  referralInfo,
  inprogress,
  enrolled,
  point,
  referralView,
  setReferralView,
  balance,
  lastTransaction
}) => {
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [program, setProgram] = useState("MBA");
  const [error, setError] = useState("");
  const [validatephone, setValidatePhone] = useState("");
  const [validateemail, setValidateEmail] = useState("");
  const [success, setSuccess] = useState("");
  const { token } = useAuth();
  const [countries, setCountries] = useState([]);
  const [proxycountry, setProxycountry] = useState("India");
  const { campaign, source, medium, saveCampaignData } = useCampaign();
  const [reedemessage, setReedemessage] = useState("");
  const [disablebutton, setDisablebutton] = useState(false);

  const formatDate = (utcTimestamp) => {
    if (!utcTimestamp) return "N/A";
    const date = new Date(utcTimestamp);
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getFilteredReferrals = () => {
    let list;
    switch (filter) {
      case "inprogress": list = inprogress; break;
      case "enrolled": list = enrolled; break;
      default: list = referralInfo;
    }
    const q = search.trim().toLowerCase();
    if (!q) return list;
    return list.filter((item) =>
      (item.candidate_name || "").toLowerCase().includes(q) ||
      (item.candidate_email || "").toLowerCase().includes(q) ||
      (item.candidate_phone || "").toLowerCase().includes(q)
    );
  };

  const filteredReferrals = getFilteredReferrals();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisablebutton(true);
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/referrals`,
        {
          candidate_name: firstname + " " + lastname,
          candidate_email: email,
          candidate_phone: phone,
          candidate_country: proxycountry,
          candidate_program: program,
          campaign: campaign,
          utm_source: source,
          medium: medium,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 201) {
        setSuccess(resp.data.message);
        setTimeout(() => {
          setSuccess("");
          setFirstname("");
          setLastname("");
          setEmail("");
          setPhone("");
          setProxycountry("India");
          setProgram("MBA");
          setReferralView(false);
          studentReferral();
          setDisablebutton(false);
        }, 2000);
        saveCampaignData("", "", "");
      }
    } catch (error) {
      console.log(error);
      setError(error.response?.data?.message || "Something went wrong");
      if (error.response?.data?.errors) {
        setValidatePhone(error.response.data.errors[0].isEmail);
        setValidateEmail(error.response.data.errors[0].isPhoneNumber);
      }
      setTimeout(() => {
        setError("");
        setValidatePhone("");
        setValidateEmail("");
        setDisablebutton(false);
      }, 3000);
    }
  };

  const redeemPointApi = async () => {
    if (balance.balance === 0 || !balance.balance) {
      setReedemessage("Points must be greater than zero to redeem rewards.");
      setTimeout(() => setReedemessage(""), 3000);
    } else {
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/points/redeem`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (resp.status === 200) {
          let ssoToken = resp.data.redirectUrl.ssoToken;
          window.open(`${process.env.REACT_APP_XOXODAY_STOREFRONT_SSO_REDIRECT_ENDPOINT_URL}/${ssoToken}`, '_blank');
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get('https://restcountries.com/v3.1/all?fields=name,flags');
      let countryNames = response.data.map(country => country.name.common);
      setCountries(countryNames.sort());
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const cancelFunction = () => {
    setProxycountry('India');
    setProgram("MBA");
    setFirstname("");
    setLastname("");
    setEmail("");
    setPhone("");
    setReferralView(false);
  };

  if (activeTab !== 1) return null;

  return (
    <div className="animate-fadeIn space-y-10 pb-10">
      {/* Quick Stats & Balance */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Balance Card */}
        <div className="col-span-1 md:col-span-2 lg:col-span-1 bg-gradient-to-br from-[#004f6b] to-[#003e54] rounded-xl p-8 text-white relative overflow-hidden group">
          <div className="hidden sm:block absolute top-0 right-0 p-8 opacity-10 group-hover:scale-110 transition-transform duration-500 pointer-events-none">
            <svg className="w-32 h-32" fill="currentColor" viewBox="0 0 24 24"><path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" /></svg>
          </div>

          <div className="relative z-10 flex flex-col justify-between h-full">
            <div>
              <h3 className="text-xs font-medium opacity-70">Current Balance</h3>
              <p className="text-4xl font-bold tracking-tight mt-2">{balance.balance || '0.00'} <span className="text-lg font-normal opacity-60 ml-1">pts</span></p>
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              <button
                onClick={() => setReferralView(true)}
                className="flex-1 py-3 bg-white text-[#004f6b] rounded-xl font-semibold text-sm hover:bg-gray-100 transition-all active:scale-95 shadow-lg"
              >
                Add Referral
              </button>
            </div>

            {reedemessage && (
              <p className="mt-4 text-sm font-medium text-red-300 animate-bounce">{reedemessage}</p>
            )}
          </div>
        </div>

        {/* Today's Limit Card */}
        <div className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm relative overflow-hidden group flex flex-col justify-between">
          <div className="hidden sm:block absolute top-0 right-0 p-8 opacity-10 group-hover:scale-110 transition-transform duration-500 pointer-events-none text-[#004f6b]">
            <svg className="w-18 h-18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          </div>
          <div className="relative z-10">
            <h3 className="text-xs font-medium text-gray-500">Today's Limit</h3>
            <p className="text-3xl font-bold tracking-tight text-amber-500 mt-2">
              {point.balance || '0.00'} <span className="text-base font-normal text-gray-400 ml-1">pts remaining</span>
            </p>
          </div>
          <div className="relative z-10 mt-6 pt-6 border-t border-gray-100">
            <p className="text-xs font-normal text-gray-400">Daily limit resets at midnight IST</p>
          </div>
        </div>

        {/* Total Redeemed Card */}
        <div className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm relative overflow-hidden group flex flex-col justify-between">
          {/* <div className="absolute -right-4 -top-4 w-24 h-24 bg-green-50 rounded-full group-hover:scale-150 transition-transform duration-700 opacity-50 pointer-events-none"></div> */}
          <div className="relative z-10">
            <h3 className="text-xs font-medium text-gray-500">Total Redeemed</h3>
            <p className="text-3xl font-bold tracking-tight text-green-500 mt-2">
              {lastTransaction?.total_points_redeemed || '0.00'} <span className="text-base font-normal text-gray-400 ml-1">pts</span>
            </p>
          </div>
          <div className="relative z-10 mt-6 pt-6 border-t border-gray-100">
            <p className="text-xs font-normal text-gray-400">Lifetime rewards earned</p>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { label: 'Total Referrals', value: referralInfo.length, color: 'blue' },
          { label: 'In Progress', value: inprogress.length, color: 'amber' },
          { label: 'Enrolled', value: enrolled.length, color: 'green' }
        ].map((stat, i) => (
          <div key={i} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm flex items-center justify-between group  transition-all">
            <div>
              <p className="text-xs font-medium text-gray-500">{stat.label}</p>
              <p className={`text-2xl font-bold mt-1 ${stat.color === 'blue' ? 'text-[#004f6b]' : stat.color === 'amber' ? 'text-amber-500' : 'text-green-500'}`}>{stat.value}</p>
            </div>
            <div className={`h-10 w-10 rounded-xl flex items-center justify-center ${stat.color === 'blue' ? 'bg-blue-50 text-blue-500' : stat.color === 'amber' ? 'bg-amber-50 text-amber-500' : 'bg-green-50 text-green-500'}`}>
              {stat.color === 'blue' && <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>}
              {stat.color === 'amber' && <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}
              {stat.color === 'green' && <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}
            </div>
          </div>
        ))}
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="px-8 py-6 border-b border-gray-100 bg-white flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
          <h3 className="text-base font-semibold text-gray-800 self-start md:self-auto">My Referrals</h3>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto">
            <div className="relative w-full sm:w-64">
              <svg className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z" />
              </svg>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by name, email, phone"
                className="w-full pl-9 pr-8 py-2.5 bg-white border border-gray-200 rounded-md text-sm font-normal text-gray-800 placeholder-gray-400 outline-none focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] transition-all"
              />
              {search && (
                <button
                  type="button"
                  onClick={() => setSearch("")}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-700"
                  aria-label="Clear search"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
            <select
              className="pl-5 pr-10 py-2.5 bg-white border border-gray-200 rounded-md text-sm font-medium text-[#004f6b] outline-none appearance-none cursor-pointer focus:ring-4 focus:ring-[#004f6b]/5 transition-all w-full sm:w-48"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="all">All Status</option>
              <option value="inprogress">In Progress</option>
              <option value="enrolled">Enrolled</option>
            </select>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left min-w-[900px]">
            <thead>
              <tr className="bg-[#004f6b]/5 border-b border-gray-100">
                <th className="px-6 py-4 text-xs font-semibold text-gray-600 text-center min-w-[80px] whitespace-nowrap">Sr. No</th>
                <th className="px-6 py-4 text-xs font-semibold text-gray-600 min-w-[220px] whitespace-nowrap">Referee</th>
                <th className="px-6 py-4 text-xs font-semibold text-gray-600 min-w-[150px] whitespace-nowrap">Contact Number</th>
                <th className="px-6 py-4 text-xs font-semibold text-gray-600 min-w-[120px] whitespace-nowrap">Status</th>
                <th className="px-6 py-4 text-xs font-semibold text-gray-600 min-w-[170px] whitespace-nowrap">Added On</th>
                <th className="px-6 py-4 text-xs font-semibold text-gray-600 text-right pr-8 min-w-[170px] whitespace-nowrap">Last Activity</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {filteredReferrals.length > 0 ? (
                filteredReferrals.map((item, index) => (
                  <tr key={index} className="group hover:bg-gray-50/50 transition-colors">
                    <td className="px-6 py-6 text-sm text-gray-300 font-mono text-center">#{index + 1}</td>
                    <td className="px-6 py-6">
                      <div className="flex flex-col">
                        <span className="text-sm font-semibold text-gray-900 group-hover:text-[#004f6b] transition-colors">{item.candidate_name}</span>
                        <span className="text-xs text-gray-500 mt-1 font-normal">{item.candidate_email}</span>
                      </div>
                    </td>
                    <td className="px-6 py-6 text-sm text-gray-700 font-normal">{item.candidate_phone || '—'}</td>
                    <td className="px-6 py-6">
                      <span className={`inline-flex px-3 py-1 rounded-lg text-xs font-medium border ${item.status === 'enrolled' ? 'bg-green-50 text-green-700 border-green-100' : 'bg-amber-50 text-amber-700 border-amber-100'
                        }`}>
                        {item.status}
                      </span>
                    </td>
                    <td className="px-6 py-6 text-xs font-normal text-gray-500 whitespace-nowrap">{formatDate(item.created_at)}</td>
                    <td className="px-6 py-6 text-right pr-8 text-xs font-normal text-gray-500 whitespace-nowrap">{formatDate(item.updated_at)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="px-8 py-20 text-center text-gray-400 font-normal">No referrals found matching the criteria.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Partners Carousel */}
      <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm overflow-hidden">
        <Carousel />
      </div>

      {/* Popup Form Modal */}
      {referralView && createPortal(
        <div className="fixed inset-0 z-[9999] flex items-start sm:items-center justify-center p-4 overflow-y-auto">
          <div
            className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm animate-fadeIn"
            onClick={cancelFunction}
          ></div>
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-4xl my-auto max-h-[calc(100vh-2rem)] overflow-y-auto animate-zoomIn border border-gray-100 overflow-x-hidden">
            <div className="sticky top-0 z-10 bg-white/95 backdrop-blur-md px-6 sm:px-12 py-6 sm:py-8 border-b border-gray-100 flex justify-between items-center">
              <div className="flex flex-col items-start">
                <h2 className="text-2xl font-bold text-gray-900 tracking-tight">Add New Referral</h2>
                <p className="text-sm text-gray-500 font-normal mt-1">Enter details to authorize a new student lead.</p>
              </div>
              <button
                onClick={cancelFunction}
                className="p-3 hover:bg-gray-100 rounded-2xl transition-colors text-gray-400 hover:text-gray-900"
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6 md:p-8 lg:p-12 space-y-4 md:space-y-6 lg:space-y-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5 lg:gap-8">
                {/* First Name */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">First Name</label>
                  <input
                    type="text"
                    placeholder="Ex: John"
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl lg:rounded-2xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    required
                  />
                </div>

                {/* Last Name */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Last Name</label>
                  <input
                    type="text"
                    placeholder="Ex: Doe"
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl lg:rounded-2xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    required
                  />
                </div>

                {/* Email */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Email Address</label>
                  <input
                    type="email"
                    placeholder="john.doe@example.com"
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl lg:rounded-2xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    required
                  />
                </div>

                {/* Country */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Country</label>
                  <select
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl lg:rounded-2xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none appearance-none transition-all font-normal text-gray-800 cursor-pointer"
                    value={proxycountry}
                    onChange={(e) => setProxycountry(e.target.value)}
                    required
                  >
                    <option value="" disabled>Select country</option>
                    {countries.map((country) => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                </div>

                {/* Phone Number */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Phone Number</label>
                  <div className="relative group">
                    <input
                      type="text"
                      placeholder="Ex: 9876543210"
                      className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl lg:rounded-2xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                      value={phone}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,10}$/.test(value)) setPhone(value);
                      }}
                      required
                    />
                    <div className="absolute inset-y-0 right-5 flex items-center pointer-events-none opacity-40 text-xs font-medium">10 Digits</div>
                  </div>
                </div>

                {/* Program */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Interested Program</label>
                  <select
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl lg:rounded-2xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none appearance-none transition-all font-normal text-gray-800 cursor-pointer"
                    value={program}
                    onChange={(e) => setProgram(e.target.value)}
                    required
                  >
                    {["MBA", "MCA", "M.Com", "MA", "BBA", "BCA", "B.Com"].map(p => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Error/Success Feedbacks */}
              {error && <div className="bg-red-50 text-red-600 px-6 py-4 rounded-xl border border-red-100 text-sm font-medium animate-shake">{error}</div>}
              {(validatephone || validateemail) && (
                <div className="bg-red-50 text-red-600 px-6 py-4 rounded-xl border border-red-100 text-xs font-medium space-y-1">
                  {validatephone && <p>• {validatephone}</p>}
                  {validateemail && <p>• {validateemail}</p>}
                </div>
              )}
              {success && <div className="bg-green-50 text-green-700 px-6 py-4 rounded-xl border border-green-100 text-sm font-medium flex items-center gap-3 animate-bounce">✓ {success}</div>}

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                 <button
                  type="button"
                  onClick={cancelFunction}
                  className="flex-1 py-3 lg:py-5 border-2 border-gray-100 text-gray-500 hover:text-gray-600 hover:bg-gray-50 rounded-xl font-semibold text-sm transition-all active:scale-95"
                >
                  Discard
                </button>
                <button
                  type="submit"
                  disabled={disablebutton}
                  className={`flex-[2] py-3 lg:py-5 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all flex items-center justify-center gap-4 active:scale-95 ${disablebutton ? 'opacity-50 grayscale' : ''}`}
                >
                  {disablebutton ? 'Processing...' : 'Save'}
                  {!disablebutton && <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}
                </button>

              </div>
            </form>
          </div>
        </div>,
        document.body
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
        .animate-zoomIn {
          animation: zoomIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        .animate-shake {
          animation: shake 0.2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Home;
